import { Result, failure, success } from '../shared'
import { AMLProvider } from './aml.provider'
import {
  AMLServiceErrorCode,
  AMLUsersServerData,
  AMLAction,
  UnslJournalAttributes,
  ZoneJournalAttributes,
  ExternalJournalAttributes,
  AddToJournalFailure,
  RiskOperJournalAttributes,
  RiskLevelsJournalAttributes,
} from './aml.types'

export class AMLService {
  constructor(private provider: AMLProvider) {}

  public async getUsers(
    action: AMLAction,
    startDate: string,
    endDate: string,
    search: string,
    RiskLevelID?: number | string,
  ): Promise<Result<AMLUsersServerData>> {
    try {
      const { data } = await this.provider.users(action, startDate, endDate, search, RiskLevelID)
      return success(data)
    } catch (error) {
      return failure(AMLServiceErrorCode.GENERAL)
    }
  }

  public async addToJournal(
    action: AMLAction,
    attributes:
      | UnslJournalAttributes
      | ZoneJournalAttributes
      | ExternalJournalAttributes
      | RiskOperJournalAttributes
      | RiskLevelsJournalAttributes,
  ): Promise<Result<void, AddToJournalFailure>> {
    try {
      await this.provider.addToJournal(action, attributes)
      return success()
    } catch (error) {
      return failure(AMLServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
